import { render, staticRenderFns } from "./GanttArrow.vue?vue&type=template&id=29b38a31&scoped=true&lang=pug&"
import script from "./GanttArrow.vue?vue&type=script&lang=js&"
export * from "./GanttArrow.vue?vue&type=script&lang=js&"
import style0 from "./GanttArrow.vue?vue&type=style&index=0&id=29b38a31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b38a31",
  null
  
)

export default component.exports